<template>
  <div class="npower-append-target-modal">
    <modal ref="modal" autoWidth closeButton @closed="onClose">
      <append-n-power-form ref="form" title="Append Audience Segments"/>
    </modal>
  </div>
</template>

<script>
  import Modal from '@/components/common/modal'
  import AppendNPowerForm from '@/appComponents/targets/createTarget/forms/AppendNPowerForm'
  // import uploadIcon from '@/assets/targetImages/upload.svg'

  export default {
    components: {
      Modal,
      AppendNPowerForm
    },
    computed: {
      showModal () {
        return this.$store.state.currentTarget.showAppendSegmentsModal
      }
    },
    methods: {
      close () {
        this.onClose()
        this.$refs.modal.close()
      },
      onClose () {
        this.$refs.form.onClose()
      },
      open () {
        this.$refs.modal.open()
      }
    },
    watch: {
      showModal (value) {
        if (value) {
          this.open()
        } else {
          this.close()
        }
      }
    }
  }
</script>

<style lang="scss">
.npower-append-target-modal .modal__container {
  width: auto !important;
  min-width: 840px !important;
}
</style>



// WEBPACK FOOTER //
// NPowerAppendTargetModal.vue?958d128e